import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/smart-scanner/page.tsx");
